/* Lite YouTube embed: swap thumbnail for iframe on first click. */
(function () {
  function activate(el) {
    var id = el.getAttribute('data-yt-id');
    if (!id || el.dataset.ytReady === '1') return;
    el.dataset.ytReady = '1';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    iframe.setAttribute('title', el.getAttribute('data-yt-title') || 'YouTube video');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;display:block;';
    el.innerHTML = '';
    el.appendChild(iframe);
  }
  function init() {
    document.querySelectorAll('[data-yt-lite]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        activate(el);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
